import overrideIfMinBetNumberEnabled from "./MinBetNumberRegistrator"

overrideIfMinBetNumberEnabled(function () {

    (function (selectionTypes) {
        if (!selectionTypes) { return; }

        var qaSelection = selectionTypes.QASelection;
        var _createEventDescriptionForLiveQASelection = qaSelection.createEventDescriptionForLiveQASelection;
        $.extend(qaSelection, {
            createEventDescriptionForLiveQASelection (selection) {
                return `
                    <div class="event_desc-mbn-wrapper">
                        ${TSlipShared.createMinBetNumberIcon(selection)}
                        ${_createEventDescriptionForLiveQASelection.apply(this, arguments)}
                    </div>
                `;
            }
        });
    })(window.TSelections);

});